import { PolicyAdjustmentRequest } from '../../../domain'

export const hasChanges = (adjustment: PolicyAdjustmentRequest) =>
  Boolean(adjustment?.changes.length) || adjustment?.adjustmentType === 'SDA'
